import * as Sentry from '@sentry/react'
Sentry.init({
  dsn: '',
  // To disable sending user data, uncomment the line below. For more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
  // dataCollection: { userInfo: false }
})

import './i18n'
import './index.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { IS_MOCK_MODE } from './libs/mocks/config'
import { mockOrganization, mockPermissions, mockUser } from './libs/mocks/fixtures/seed'

// Auto-seed a superadmin session in mock mode so the preview lands
// directly into the app (and /admin) without a login round-trip.
if (IS_MOCK_MODE === true && !localStorage.getItem('isAuthenticated')) {
  localStorage.setItem('isAuthenticated', 'true')
  localStorage.setItem('authToken', 'mock-access-token')
  localStorage.setItem('refreshToken', 'mock-refresh-token')
  localStorage.setItem('user', JSON.stringify(mockUser))
  localStorage.setItem('permissions', JSON.stringify(mockPermissions))
  localStorage.setItem('currentOrganization', JSON.stringify(mockOrganization))
}

import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
